import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createToast, isVisible, setClosingTransition, setDirection } from 'redux/toast/slice';

type ToastProps = {
  transitionTime?: number;
  direction?: string;
  autoClose?: number | null;
};

export const useToastCustom = () => {
  const dispatch = useDispatch();
  const transitionTime = 200;

  useEffect(() => {
    return () => {
      dispatch(isVisible(false));
    };
  }, [dispatch]);

  const timeOut = (callback: Function, timer: number) => setTimeout(callback, timer);

  const openToast = () => {
    dispatch(isVisible(true));
  };

  const startAnimationend = () => {
    timeOut(() => {
      dispatch(isVisible(false));
      dispatch(setClosingTransition(false));
    }, transitionTime);
  };

  const closeToast = () => {
    dispatch(setClosingTransition(true));
    startAnimationend();
  };

  const closeAutomatically = (timer: number) => timeOut(closeToast, timer);

  const handleOpen = () => {
    openToast();
  };

  const handleClose = () => {
    closeToast();
  };

  const toast = (element: JSX.Element, options?: ToastProps) => {
    dispatch(setDirection(options?.direction));
    dispatch(createToast(element));
    openToast();
    if (options && options.autoClose) closeAutomatically(options.autoClose);
  };

  return { toast, handleClose, handleOpen };
};
